import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1, { Span } from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaPaintBrush,
  FaCode,
  FaUsers,
  FaHandshake,
  FaAward,
  FaLightbulb,
} from "react-icons/fa";
import Faq from "../../../Faq.js";

// Styled Components for Main Content
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const MainHeading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const MainDescription = tw.p`text-base text-black md:text-lg lg:text-xl`;

// Main Component
export const WebsiteDesignAndDevelopmentCompanyInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Dubai Web Development and Design Company" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Your Partner of Choice for Custom Web Solutions</Subheading>}
        heading={
          <MainHeading>
            Lift Your Business Higher with a <Span>Web Design and Development Firm in Dubai</Span>
          </MainHeading>
        }
        description={
          <MainDescription>
            MilaajBrandset is a top-rated <strong>website design and development company in Dubai</strong>, specialized in designing tailor-made web solutions that drive business. Our <strong>web developers and designers in Dubai</strong> mix technical knowledge with creative vision to deliver stunning, responsive, and high-performance websites. From corporate websites to e-commerce sites, or custom web applications, our personalized services address your requirements and deliver quantifiable results in the UAE business space.
          </MainDescription>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=1000",
          "https://images.unsplash.com/photo-1552664730-d307ca884978?w=1000",
          "https://images.unsplash.com/photo-1517245386807-bb43011b1b38?w=1000"
        ]}
        imageAlts={[
          "Dubai web development and design firm providing bespoke web solutions",
          "Team working on web development and design in Dubai for UAE businesses",
          "Creative brainstorming at a web design and development company in Dubai"
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;"
        ]}
        primaryButtonText="Go Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Your First-Class Website Design and Development Professionals in Dubai"
        description="We blend creativity, innovation, and technical know-how to provide superior web solutions specifically for Dubai businesses."
        cards={[
          {
            icon: <FaPaintBrush color="#ff5464" size={40} />,
            title: "Stunning Visual Designs",
            description: "Our web design specialists in Dubai design stunning websites that capture your brand image and engage your audience in the competitive Dubai market."
          },
          {
            icon: <FaCode color="#ff5464" size={40} />,
            title: "Technical Skills",
            description: "With decades of experience in developing commercial websites, our professionals leverage the most advanced technologies to build scalable and robust web solutions for UAE businesses."
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Audience-Centric Design",
            description: "We prioritize user experience and easy functionality, designing sites that resonate with Dubai's tech-savvy and multicultural audience."
          },
          {
            icon: <FaHandshake color="#ff5464" size={40} />,
            title: "Client-Oriented Solutions",
            description: "Our web development and web design in Dubai are designed to address your specific business requirements and deliver maximum ROI."
          },
          {
            icon: <FaAward color="#ff5464" size={40} />,
            title: "Proven Track Record",
            description: "Highly respected by companies across Dubai, from Downtown to Jumeirah, we deliver exceptional results that create online presence and drive growth."
          },
          {
            icon: <FaLightbulb color="#ff5464" size={40} />,
            title: "Creative Excellence",
            description: "Our creative web design in Dubai approach introduces new outlooks, making sure your site is one of a kind in the UAE online world."
          }
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="How Our Effective Website Design Process Works"
        description={
          <MainDescription>
            Our proven process ensures quality, effectiveness, and measurable outcomes for Dubai businesses:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery & Research: Studying your business and the market of Dubai to understand your target audience.</li>
              <li>Planning & Strategy: Establishing goals, features, and technical specifications for a solid web solution.</li>
              <li>Design Development: Developing visually stunning, responsive designs that are user experience-optimized.</li>
              <li>Development & Testing: Creating and thoroughly testing your site for performance and search engine optimization in the UAE.</li>
              <li>Launch & Support: Launching your site and supporting it for long-term success.</li>
            </ul>
          </MainDescription>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1587620962725-abab7fe55159?w=1000",
          "https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=1000",
          "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1000"
        ]}
        imageAlts={[
          "Dubai web development and design firm streamlining web development process",
          "Team planning website design and development in Dubai for UAE projects",
          "Coding environment for Dubai-based web design and development company"
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;"
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Transformatory Outcomes for Dubai Enterprises"
        description="With our web development and web design services, Dubai companies have been able to attain enormous online success."
        cards={[
          {
            icon: <FaAward color="#ff5464" size={40} />,
            title: "Improved User Experience",
            description: "One Dubai-based startup saw its user activity increase by 60% within the first three months, due to our responsive web design and SEO strategies."
          },
          {
            icon: <FaHandshake color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "Maintained a 98% client retention rate through the delivery of tailored web solutions that meet the unique needs of UAE businesses."
          },
          {
            icon: <FaLightbulb color="#ff5464" size={40} />,
            title: "Improved Performance",
            description: "Increased website page loads by 50% for a Dubai store, lowering bounce rates and search engine rankings."
          }
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Elevate Your Online Presence?</Subheading>}
        heading="Work with Dubai's Top Web Design Experts"
        description={
          <MainDescription>
            Collaborate with Dubai's top <strong>website development and design company</strong> to unleash your business's full potential on the internet. With tailored web development, e-commerce, and online marketing, we provide full-cycle solutions to help you succeed in the competitive UAE marketplace.
          </MainDescription>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1000",
          "https://images.unsplash.com/photo-1560439514-4e9645039924?w=1000",
          "https://images.unsplash.com/photo-1529400971008-f566de0db4b0?w=1000"
        ]}
        imageAlts={[
          "Web design and development firm Dubai congratulating on success of web project",
          "Business partnership with Dubai website design and development for UAE solutions",
          "Business partnership in a Dubai web design and development company"
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;"
        ]}
        primaryButtonText="Contact Us Today"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* FAQ Section */}
      <Faq
        page={true}
        faqs={[
          {
            question: "What services does MilaajBrandset offer?",
            answer:
              "As one of the top <strong>website design and development companies in Dubai</strong>, MilaajBrandset offers a complete range of web services including custom web design, expert website development, e-commerce solutions, digital marketing, API development, and UI/UX design. We specialize in creating customized digital solutions for Dubai and UAE businesses."
          },
          {
            question: "How long do web development projects typically take to complete?",
            answer:
              "The timeframe of our web development projects in Dubai varies with the level of complexity. The typical website would take 4-6 weeks time, while heavy web applications with intricate features take 3-6 months' time. We are Dubai's top <strong>web development company</strong> with transparent timelines, and we update regularly with transparency."
          },
          {
            question: "Do you offer support and maintenance once the website has been launched?",
            answer:
              "Absolutely, our <strong>website development and designing company in Dubai</strong> offers full ongoing support and maintenance packages. Your website remains safe, updated, and performance optimized, allowing your business to succeed in the UAE market."
          },
          {
            question: "Will you help migrate my existing website to a new platform?",
            answer:
              "Absolutely! Our Dubai web development experts are skilled in seamless website migrations, migrating your content, databases, and functionality to the new platform hassle-free while bringing enhanced performance and user experience in the UAE online world."
          },
          {
            question: "How do you guarantee website security?",
            answer:
              "At MilaajBrandset, one of Dubai's top <strong>web development firms</strong>, we guarantee website security by using SSL certificates, regular audits, secure coding, and robust firewalls, so we are always in line with UAE digital standards."
          },
          {
            question: "Do you provide SEO services alongside web development?",
            answer:
              "Yes, our Dubai digital marketing services include full-cycle SEO solutions, such as on-page optimization, keyword research, and technical SEO, to enhance your website's visibility and organic traffic in the UAE."
          }
        ]}
      />
    </AnimationRevealPage>
  );
};